import { Component, inject, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ControlContainer, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { generateInputId, GenerateInputIdPipe } from '../../../../shared/pipes/generate-input-id.pipe';
import { SubscriptionComponent } from '../../../../shared/helpers/subscription.component';
import { OrganizationPersonObject } from '@it2go/types';
import { EditPersonFormStore } from './edit-person-form.store';
import { FilterBuilder } from '../../../helper/filter.builder';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { DateInputComponent } from '../../../../../components/kit/input/date-input/date-input.component';
import { EmailInputComponent } from '../../../../../components/kit/input/text-input/email-input.component';
import { PasswordInputComponent } from '../../../../../components/kit/input/password-input/password-input.component';
import { TextInputComponent } from '../../../../../components/kit/input/text-input/text-input.component';
import {
    SelectUserGroupComponent,
} from '../../../../../components/user-management/user-detail/user-role/select-user-group/select-user-group.component';
import {
    SelectButtonSexInputComponent,
} from '../../../../../components/kit/input/select-button-input/select-button-sex-input.component';
import { getPersonsFrag } from './edit-person-form.query';
import { formatPerson } from '@libs/shared/helpers/person.utils';
import { InputExistingComponent } from '../../../../shared/components/inputs/input-existing/input-existing.component';

@Component({
    selector: 'app-edit-person-form',
    templateUrl: './edit-person-form.component.html',
    styleUrls: ['edit-person-form.component.scss'],
    providers: [EditPersonFormStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ReactiveFormsModule,
        TranslatePipe,
        DateInputComponent,
        GenerateInputIdPipe,
        InputExistingComponent,
        NgClass,
        EmailInputComponent,
        PasswordInputComponent,
        TextInputComponent,
        SelectUserGroupComponent,
        SelectButtonSexInputComponent,
    ],
})
export class EditPersonFormComponent extends SubscriptionComponent implements OnInit {
    protected readonly store = inject(EditPersonFormStore);
    protected readonly controlContainer = inject(ControlContainer);

    @Input() idPrefix = '';
    @Input() translatePrefix = '';
    @Input() showTitle = false;
    @Input() showDateTo = false;
    @Input() enablePersonSelect = false;

    form!: FormGroup;

    personOptions: Record<string, number | string>[] = [];

    public async ngOnInit() {
        this.form = this.controlContainer.control as FormGroup;
        if (this.enablePersonSelect) {
            const persons = (await this.store.api.getOrganizationCenterPersons(FilterBuilder.singlePage({}), getPersonsFrag))?.items;
            this.personOptions = persons?.['items']?.map((person: OrganizationPersonObject) => ({
                id: person.id,
                name: formatPerson(person),
            })) ?? [];
        }
    }

    get isExistingPersonSelected(): boolean {
        return this.form.value[generateInputId('chosenPersonId', this.idPrefix)] !== null;
    }

}
